import React, { Component } from 'react';
import { connect } from 'react-redux';
import styles from './PrintDialog.scss';
import Checkbox from 'components/common/Checkbox';
import ScrollLock from 'components/ScrollLock';
import cn from 'classnames';

import { loadChess } from 'actions/building';
import { setPopUp } from 'actions/environment';

import { compileQuery } from 'utils';
import { ROOT_URL } from '../../../constants/Config';
import { withTranslation } from 'react-i18next';
import { gaEvent, trackGA } from 'services/ga';

class PrintDialog extends Component {

  constructor(props) {
    super(props);
    this.state = {
      query: {},
      chess: {},
      plans: {},
      didReceiveSections: false
    };
  }

  componentDidMount() {
    this.setState({
      chess: this.getGroup('chess', false)
    });
    // awkward code to load all chess sections
    this.sections = this.props.pavilions.reduce(
      (sections, pavilion) => (
        {
          ...sections,
          ...(pavilion.sections.reduce(
            (sections, section) => (
              {
                ...sections,
                [section.id]: { ...section, pavilionName: pavilion.name }
              }
            ), {}
          ))
        }
      ), {}
    );

    Object.keys(this.sections).map(
      sectionId => this.props.loadChess({ id: sectionId })
    );

    this.checkSections(this.props);
  }

  componentWillUnmount() {
    this.handleTrackEvent({
      eventName: 'buildingPrintButtonsClick',
      eventLabel: 'zakryt'
    });
  }

  checkSections(props) {
    if (!this.state.didReceiveSections && Object.keys(this.sections).every(sectionId => props.chessList[sectionId])) {
      const plans = {};
      Object.keys(props.chessList).forEach(
        (sectionId) => (
          props.chessList[sectionId].cells.forEach(
            ({ planId, row }) => {
              if (planId) {
                const plan = plans[planId] || { floor: new Set() };
                const floor = plan.floor.add(row + 1);
                plans[planId] = { ...(plan), floor, section: sectionId };
              }
            }
          )
        )
      );

      this.setState(
        {
          didReceiveSections: true,
          plansData: plans
        },
        () => {
          this.setState({
            plans: this.getGroup('plans', false)
          });
        }
      );
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.checkSections(nextProps);
  }

  getGroup = (group, val) => {
    switch (group) {
      case 'chess': {
        return this.props.pavilions
        .reduce((pavilions, p) => pavilions.concat(p.sections), [])
        .reduce((sections, section) => { sections[`${group}${section.id}`] = val; return sections; }, {});
      }
      case 'plans': {
        return Object.keys(this.state.plansData)
        .reduce((plans, planId) => { plans[`${group}${planId}`] = val; return plans; }, {});
      }
      default: {
        return {};
      }
    }
  }

  handlePrintClick = () => {
    this.handleTrackEvent({
      eventName: 'buildingPrintButtonsClick',
      eventLabel: 'raspechatat'
    });
    this.props.setPopUp();
  }

  handlePrintSectionClick = (group) => {
    this.setState({
      [group]: this.getGroup(group, !Object.values(this.state[group]).some(this.id))
    });
    const isChecked = Object.values(this.state[group]).some((item) => item === true);

    let name = '';
    switch (group) {
      case 'chess':
        name = 'шахматки';
        break;
      case 'plans':
        name = 'планировки';
        break;
      default:
        break;
    }

    this.handleTrackEvent({
      eventName: 'buildingPrintCheckboxesPick',
      eventContent: `${name} | ${isChecked ? 'off' : 'on'}`
    });
  }

  handlePrintItemClick = (name, group, text, title) => {
    const isChecked = group ? this.state[group][`${group}${name}`] : this.state.query[name];

    this.handleTrackEvent({
      eventName: 'buildingPrintCheckboxesPick',
      eventContent: `${text}_${title} | ${isChecked ? 'off' : 'on'}`
    });

    if (group) {
      this.setState({
        [group]: {
          ...this.state[group],
          [`${group}${name}`]: !this.state[group][`${group}${name}`]
        }
      });
    } else {
      this.setState({
        query: {
          ...this.state.query,
          [name]: !this.state.query[name]
        }
      });
    }
  }

  id = _ => _

  not = _ => !_

  renderPrintItem = ({ title, name, group, text }) => (
    <div
      className={group ? styles.CheckItemInner : styles.CheckItem}
      key={name}
    >
      <div className={styles.Checkbox}>
        <Checkbox
          innerStyle={group ? styles.ChessCheckInner : styles.ChessCheckInner}
          classNameClone="CheckboxClonePrint"
          text={<span>{title}</span>}
          checked={group ? this.state[group][`${group}${name}`] : this.state.query[name]}
          handle={this.handlePrintItemClick.bind(this, name, group, text, title)}
        />
      </div>
    </div>
    )

  getRanges = (array) => {
    let ranges = [],
      rstart,
      rend;
    for (let i = 0; i < array.length; i++) {
      rstart = array[i];
      rend = rstart;
      while (array[i + 1] - array[i] === 1) {
        rend = array[i + 1]; // increment the index if the numbers sequential
        i++;
      }
      ranges.push(rstart === rend ? `${rstart}` : `${rstart} — ${rend}`);
    }
    return ranges;
  }

  handleTrackEvent = ({ eventName, eventLabel, eventContent }) => {
    const { building, profile, objectType } = this.props;
    const { data: { title, id } } = building;

    trackGA(gaEvent[eventName]({
      eventLabel,
      eventContent: eventContent || title,
      productType: objectType,
      productName: title,
      productID: id,
      user_id: profile.id
    }));
  };

  render() {
    const { pavilions, params, buildingInfo, building: { data: { description } }, t } = this.props;
    const isDescriptionExists = !!description.length;
    const items = [];
    pavilions.forEach((pavilion) => {
      const { sections } = pavilion;
      if (sections) {
        sections.forEach((section) => {
          items.push(
            this.renderPrintItem({
              title: t('components.building.main.printDialog.item', {
                pavilion: pavilion.name,
                section: section.name
              }),
              name: `${section.id}`,
              group: 'chess',
              text: 'шахматка'
            })
          );
        });
      }
    });

    let year,
      quarter;
    let check = 20994; // 2099 г. 4 кв.
    const finished = (pavilions || []).some((pavilion) => {
      const { construction_finished, year_built, construction_ending } = pavilion;
      const current = Number(`${year_built}${construction_ending}`);
      if (year_built && construction_ending && check > current) {
        check = current;
        year = year_built; quarter = construction_ending;
      }
      return construction_finished;
    });
    const deadline = finished
        ? t('components.building.main.printDialog.finished') : ((year === 0) ? t('components.building.main.printDialog.inProgress')
        : ((year && quarter) ? `${quarter} / ${year}` : ''));
    const statusClass = finished ? styles.Finished : styles.NotFinished;

    return (
      <div>
        { (this.props.pavilions && !this.state.plansData) ? (
          <div className={styles.Loader} />
        ) : (
          <div className={styles.PopupContent}>
            <div className={styles.PopupHeader}>
              {t('components.building.main.printDialog.print')}
            </div>
            <div className={styles.ObjectInfo}>
              {buildingInfo.imageId ?
                <div className={styles.ObjectInfoImage}>
                  <img
                    src={
                          `${ROOT_URL}/image?id=${buildingInfo.imageId}&size=small`
                        }
                    alt=""
                  />
                </div>
                  : null}
              <div className={styles.ObjectInfoText}>
                <div className={styles.ObjectInfoTitle}>
                  {buildingInfo.title}
                </div>
                <div className={styles.ObjectInfoAddress}>
                  {buildingInfo.subregion}, {buildingInfo.address}
                </div>
              </div>
              <div className={cn(styles.ObjectInfoStatus, statusClass)}>
                {deadline}
              </div>
            </div>
            <ScrollLock>
              <div className={cn(styles.PrintPopupContent, 'custom-scrollbar')}>
                {
                  this.renderPrintItem({
                    title: t('components.building.main.printDialog.info'),
                    name: 'info',
                    text: 'информация'
                  })
                }
                {isDescriptionExists &&
                this.renderPrintItem({
                  title: t('components.building.main.printDialog.about'),
                  name: 'desc',
                  text: 'описание'
                })
                }
                {
                  this.renderPrintItem({
                    title: t('components.building.main.printDialog.contacts'),
                    name: 'contacts',
                    text: 'контакты'
                  })
                }

                <div className={cn(styles.CheckItem, styles.WithInner)} key="chess">
                  <div className={styles.Checkbox}>
                    <Checkbox
                      innerStyle={styles.ChessCheckInner}
                      classNameClone="CheckboxClonePrint"
                      text={<span>{t('components.building.main.printDialog.chess')}</span>}
                      checked={!Object.values(this.state.chess).some(this.not)}
                      partialChecked={Object.values(this.state.chess).some(this.id)}
                      handle={this.handlePrintSectionClick.bind(this, 'chess')}
                    />
                  </div>
                  { items }
                </div>

                {
                  this.state.plansData && Object.keys(this.state.plansData).length ?
                    <div className={cn(styles.CheckItem, styles.WithInner)} key="plans">
                      <div className={styles.Checkbox}>
                        <Checkbox
                          innerStyle={styles.ChessCheckInner}
                          classNameClone="CheckboxClonePrint"
                          text={<span>{t('components.building.main.printDialog.planning')}</span>}
                          checked={!Object.values(this.state.plans).some(this.not)}
                          partialChecked={Object.values(this.state.plans).some(this.id)}
                          handle={this.handlePrintSectionClick.bind(this, 'plans')}
                        />
                      </div>

                      {
                          Object.keys(this.state.plansData).map(
                              planId => {
                                const plan = this.state.plansData[planId];
                                return this.renderPrintItem({
                                  title: t('components.building.main.printDialog.plans', {
                                    pavilionName: this.sections[plan.section].pavilionName,
                                    section: this.sections[plan.section].name,
                                    floor: this.getRanges([...plan.floor]).join(', ')
                                  }),
                                  name: `${planId}`,
                                  group: 'plans',
                                  text: 'план'
                                });
                              }
                          )
                        }
                    </div> : null
                }
              </div>
            </ScrollLock>

            <div className={styles.PopupFooter}>
              <a
                href={`/print/${params.id}/?${compileQuery({ ...this.state.query, ...this.state.chess, ...this.state.plans })}`}
                className={cn(styles.PopupPrintBtn, 'button-primary', 'button-primary--md')}
                onClick={this.handlePrintClick}
                target="_blank"
              >
                {t('components.building.main.printDialog.print1')}
              </a>
            </div>
          </div>
        ) }
      </div>
    );
  }
}

export default withTranslation()(
  connect(
    state => ({
      pavilions: state.building.pavilions,
      chessList: state.building.chessList
    }),
    { setPopUp, loadChess }
  )(PrintDialog)
);



// WEBPACK FOOTER //
// ./src/components/Building/PrintDialog/PrintDialog.js